import { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import AuthButton from "../AuthButton/AuthButton";
import Input from "../Input/Input";
import { LOGOUTLOADER, Logout, POPUP, getstatsassets, refreshToken } from "../../Actions/actions";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
// import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Loader from "../Loader/Loader";
import DropDownCustom from "../DropDownCustom/DropDownCustom";
import { toast } from "react-toastify";
import CustomToast from "../CustomToast/CustomToast";
import { useDispatch } from "react-redux";

const AssetCreationModal = ({ isOpen, onClose, heading, need, edit, setEdit, setchange, change }) => {
  const dispatch = useDispatch();

  const { loginData, employeesData, singleAsset } = useSelector((state) => state.userReducer);
  // const [allAssets, setAllAssets] = useState([]);
  // const getAssets = () => {
  //   try {
  //     const myHeaders = new Headers();
  //     myHeaders.append("Authorization", `Bearer ${loginData?.accessToken}`);
  //     myHeaders.append("Content-Type", "application/json");

  //     const requestOptions = {
  //       method: "GET",
  //       headers: myHeaders,
  //       redirect: "follow",
  //     };

  //     fetch(`${BaseUrl}/api/asset-types`, requestOptions)
  //       .then(async (response) => {
  //         console.log(response.status, "response.status");
  //         if (response.status === 401) {
  //           const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
  //           if (rememberMe) {
  //   refreshToken();
  // } else {
  //   Logout(token, () => {
  //     dispatch({
  //       type: ACTIVETAB,
  //       payload: "Dashboard",
  //     });
  //     window.location.href = "/";
  //   });
  // }
  //         }
  //         const result = await response.json();
  //         return result;
  //       })
  //       .then((result) => {
  //         dispatch({ type: LOGOUTLOADER, payload: true });
  //         console.log(result);
  //         setAllAssets(result?.assetTypes);
  //         dispatch({ type: LOGOUTLOADER, payload: false });
  //       })
  //       .catch((error) => {
  //         dispatch({ type: LOGOUTLOADER, payload: false });
  //         console.error(error);
  //       });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // useEffect(() => {
  //   getAssets();
  // }, []);
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({
    assetType: "",
    assetId: "",
    description: "",
    networkProvider: "",
    phoneNumber: "",
    manufacturer: "",
    modelNumber: "",
  });
  const [formData, setFormData] = useState({
    assetType: "",
    assetId: "",
    description: "",
    networkProvider: "",
    phoneNumber: "",
    manufacturer: "",
    modelNumber: "",
  });

  useEffect(() => {
    let data = {
      assetType: singleAsset?.assetType ? singleAsset?.assetType : "",
      assetId: singleAsset?.assetId ? singleAsset?.assetId : "",
      description: singleAsset?.description ? singleAsset?.description : "",
      networkProvider: singleAsset?.networkProvider ? singleAsset?.networkProvider : "",
      phoneNumber: singleAsset?.phoneNumber ? singleAsset?.phoneNumber : "",
      manufacturer: singleAsset?.manufacturer ? singleAsset?.manufacturer : "",
      modelNumber: singleAsset?.modelNumber ? singleAsset?.modelNumber : "",
    };
    setFormData({ ...data });
  }, [singleAsset]);
  console.log(singleAsset, "form");
  const ReportOption = [
    { value: "Report 1", label: "Report 1" },
    { value: "Report 2", label: "Report 2" },
  ];
  const salesRepOptions = employeesData?.map((source) => ({
    value: source.id,
    label: source.FullName,
  }));
  const selectedSalesRep = salesRepOptions?.find((option) => option.value === formData.employeeId);
  const tabs = [
    { label: "Cars", lab: "Car" },
    { label: "Mobiles", lab: "Mobile" },
    { label: "Sim Cards", lab: "Sim Card" },
    { label: "Laptops", lab: "Laptop" },
    // { label: "Fuel Consumption", lab: "Fuel Consumption", },
  ];
  const assetOptions = tabs?.map((source) => ({
    value: source.label,
    label: source.lab,
  }));
  const selectedValue = assetOptions?.find((option) => option.value === formData.assetType);
  const handleChanges = (selectedOption) => {
    setFormData((prevState) => ({
      ...prevState,
      assetType: selectedOption.value,
      //   assetId: selectedOption.value,
      ...(selectedOption.value !== "Sim Cards"
        ? {
            networkProvider: "",
            phoneNumber: "",
          }
        : {
            manufacturer: "",
            modelNumber: "",
          }),
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      assetType: "",
      ...(selectedOption.value !== "Sim Cards"
        ? {
            networkProvider: "",
            phoneNumber: "",
          }
        : {
            manufacturer: "",
            modelNumber: "",
          }),
    }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const validateForm = () => {
    let valid = true;
    let newErrors = {
      assetType: "",
      assetId: "",
      description: "",
      networkProvider: "",
      phoneNumber: "",
      manufacturer: "",
      modelNumber: "",
    };

    if (!formData.assetType) {
      newErrors.assetType = "Asset Type field is required";
      valid = false;
    }
    if (need && !formData.assetId) {
      newErrors.assetId = "Asset Id is required";
      valid = false;
    }
    if (formData.assetType !== "Sim Cards" && !formData.manufacturer) {
      newErrors.manufacturer = "Manufacturer is required";
      valid = false;
    }
    if (formData.assetType !== "Sim Cards" && !formData.modelNumber) {
      newErrors.modelNumber = "Model Number is required";
      valid = false;
    }
    if (formData.assetType === "Sim Cards" && !formData.networkProvider) {
      newErrors.networkProvider = "Network Provider is required";
      valid = false;
    }
    if (formData.assetType === "Sim Cards" && !formData.phoneNumber) {
      newErrors.phoneNumber = "Phone Number is required";
      valid = false;
    }
    if (!formData.description) {
      newErrors.description = "Description is required";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData, "form Data is here");
    if (!validateForm()) return;

    try {
      setLoader(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${loginData?.accessToken}`);
      myHeaders.append("Content-Type", "application/json");
      const parsedData = {
        ...formData,
        ...(formData.assetType !== "Sim Cards"
          ? {
              networkProvider: "",
              phoneNumber: "",
            }
          : {
              manufacturer: "",
              modelNumber: "",
            }),
      };
      const raw = JSON.stringify(parsedData);
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        redirect: "follow",
        body: raw,
      };

      fetch(`${BaseUrl}/api/asset-types`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(loginData?.accessToken, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            setchange(!change);
            toast.success(<CustomToast type={"Success"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
            setFormData({
              assetType: "",
              assetId: "",
              description: "",
              networkProvider: "",
              phoneNumber: "",
              manufacturer: "",
              modelNumber: "",
            });
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          setLoader(false);
          console.log("create assets: ", result);
          onClose();
          setEdit(false);
        })
        .catch((error) => {
          setLoader(false);
          console.error(error);
        });
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  const handleEdit = (e) => {
    e.preventDefault();
    console.log(formData, "form Data is here");
    if (!validateForm()) return;

    try {
      setLoader(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${loginData?.accessToken}`);
      myHeaders.append("Content-Type", "application/json");

      const parsedData = {
        ...formData,
        ...(formData.assetType !== "Sim Cards"
          ? {
              networkProvider: "",
              phoneNumber: "",
            }
          : {
              manufacturer: "",
              modelNumber: "",
            }),
      };
      const raw = JSON.stringify(parsedData);
      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        redirect: "follow",
        body: raw,
      };

      fetch(`${BaseUrl}/api/asset-types/${singleAsset?.id}`, requestOptions)
        .then(async (response) => {
          console.log(response.status, "response.status");
          if (response.status === 401) {
            const rememberMe = JSON.parse(localStorage.getItem("rememberMe")) || false;
            if (rememberMe) {
              refreshToken();
            } else {
              dispatch(Logout(loginData?.accessToken, () => {}));
              localStorage.removeItem("accessToken");
              localStorage.removeItem("refreshToken");
              window.location.href = "/";
            }
          }
          const result = await response.json();
          return result;
        })
        .then((result) => {
          if (result.success == true) {
            setchange(!change);
            setFormData({
              assetType: "",
              assetId: "",
              description: "",
              networkProvider: "",
              phoneNumber: "",
              manufacturer: "",
              modelNumber: "",
            });
            toast.success(<CustomToast type={"Success"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          } else {
            toast.success(<CustomToast type={"Error"} message={result?.message} />, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
              icon: false,
              closeButton: false,
            });
          }
          setLoader(false);
          console.log("edit assets: ", result);
          onClose();
          setEdit(false);
        })
        .catch((error) => {
          setLoader(false);
          console.error(error);
        });
    } catch (error) {
      setLoader(false);
      console.log(error);
    }
  };
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* Overlay */}
      <div
        className="bg-gray-900 opacity-50 fixed inset-0"
        onClick={() => {
          setEdit(false);

          onClose();
        }}
      ></div>

      {/* Popup */}
      <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] md:w-[40%] relative z-10">
        <button
          className="absolute top-7 right-5 text-gray-500 hover:text-gray-700"
          onClick={() => {
            setEdit(false);

            onClose();
          }}
        >
          <AiOutlineClose size={20} />
        </button>

        <h2 className="text-xl font-semibold mb-6">{heading}</h2>

        <form onSubmit={edit ? handleEdit : handleSubmit} className="">
          {need ? (
            <div>
              <DropDownCustom
                selectedValue={selectedValue}
                handleChanges={handleChanges}
                options={assetOptions}
                isSearchable={false}
                label="Asset Type*"
                placeholder={"Select Asset Type"}
              />

              {errors.assetType && <p className="text-red-500 text-sm">{errors.assetType}</p>}
              <div className="mt-6"></div>
              <Input
                type="text"
                label={"Asset Id*"}
                name={"assetId"}
                float={true}
                value={formData.assetId}
                onChange={handleChange}
                placeholder="Asset Id"
              />
              {errors.assetId && <p className="text-red-500 text-sm">{errors.assetId}</p>}
              <div className="mt-6"></div>
              <Input
                type="text"
                label={"Description*"}
                name={"description"}
                float={true}
                value={formData.description}
                onChange={handleChange}
                placeholder="Description"
              />
              {errors.description && <p className="text-red-500 text-sm">{errors.description}</p>}
              <div className="mt-6"></div>

              {selectedValue?.value === "Sim Cards" ? (
                <>
                  <div className="mt-6"></div>
                  <Input
                    type="text"
                    label={"Network Provider*"}
                    name={"networkProvider"}
                    float={true}
                    value={formData.networkProvider}
                    onChange={handleChange}
                    placeholder="Network Provider"
                  />
                  {errors.networkProvider && <p className="text-red-500 text-sm">{errors.networkProvider}</p>}
                </>
              ) : (
                <>
                  <Input
                    type="text"
                    label={"Manufacturer*"}
                    name={"manufacturer"}
                    float={true}
                    value={formData.manufacturer}
                    onChange={handleChange}
                    placeholder="Manufacturer"
                  />
                  {errors.manufacturer && <p className="text-red-500 text-sm">{errors.manufacturer}</p>}
                </>
              )}
            </div>
          ) : (
            <div className="-mt-5">
              <DropDownCustom
                selectedValue={ReportOption?.find((option) => option.value === formData.assetType)}
                handleChanges={(e) => {
                  setFormData({ ...formData, assetType: e.value });
                }}
                options={ReportOption}
                isSearchable={false}
                label="Report Type"
                placeholder={"Select Report Type"}
              />
              {errors.assetType && <p className="text-red-500 text-sm">{errors.assetType}</p>}
            </div>
          )}
          {selectedValue?.value === "Sim Cards" ? (
            <>
              <div className="mt-6"></div>
              <Input
                type="text"
                label={"Phone Number*"}
                name={"phoneNumber"}
                float={true}
                value={formData.phoneNumber}
                onChange={handleChange}
                placeholder="Phone Number"
              />
              {errors.phoneNumber && <p className="text-red-500 text-sm">{errors.phoneNumber}</p>}
            </>
          ) : (
            <>
              {need ? (
                <div className="mt-6">
                  <Input
                    type="text"
                    label={"Model Number*"}
                    name={"modelNumber"}
                    float={true}
                    value={formData.modelNumber}
                    onChange={handleChange}
                    placeholder="Model Number"
                  />
                  {errors.modelNumber && <p className="text-red-500 text-sm">{errors.modelNumber}</p>}
                </div>
              ) : null}
            </>
          )}

          {errors.employeeId && <p className="text-red-500 text-sm">{errors.employeeId}</p>}
          <div className="flex justify-end mt-6 space-x-4">
            <AuthButton
              onClick={() => {
                setEdit(false);

                onClose();
              }}
              className="bg-white px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100"
              width={"20%"}
              title={"Cancel"}
            />
            {loader ? (
              <Loader />
            ) : (
              <AuthButton
                width={"20%"}
                title={edit ? "Edit" : "Generate"}
                className="px-4 py-2 text-white rounded-md"
              />
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default AssetCreationModal;
